// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"189":"c38a47e0","512":"09f860d1"}[chunkId] + ".chunk.css";
};